export default __webpack_public_path__ + "static/media/easytouse.5541651a.svg";